import React from "react";
import "./App.css";
import Home from "./routes/home";
import About from "./routes/about";
import Service from "./routes/service";
import Contact from "./routes/contact";
import { Route, Routes, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import Troubleshoot from "./routes/Troubleshoot";
import SignUp from "./routes/signup";
import Terms from "./routes/terms_of_service";
import Login from "./routes/login";
import ForgotPass from "./routes/forgot_password";
import PassReset from "./routes/resetpassword";
import TourDetail1 from "./components/tour_details1";
import TourDetail2 from "./components/tour_details2";
import TourDetail3 from "./components/tour_details3";
import BookingPage from "./components/booking";
import PrivacyPolicy from "./routes/pri_policy";
import Cookie from "./routes/cookie_policy";
import GhostSignIn from "./routes/ghostsignin";



const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};

function App() {
  return (
    <div className="App">
      <Wrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Troubleshoot" element={<Troubleshoot />}/>
          <Route path="signup" element={<SignUp />}/>
          <Route path="/terms_of_service" element={<Terms />} />
          <Route path="/login" element={<Login/>} />
          <Route path="/forgot_password" element={<ForgotPass/>} />
          <Route path="/resetpassword" element={<PassReset />} />
          <Route path="/tour/1" element={<TourDetail1/>} /> 
          <Route path="/tour/2" element={<TourDetail2/>} />
          <Route path="/tour/3" element={<TourDetail3/>} />
          <Route  path="/booking" element={<BookingPage/>} />
          <Route path="/pri_policy" element={<PrivacyPolicy/>} />
          <Route path="/cookie_policy" element={<Cookie/>} />
          <Route path="/ghostsignin" element={<GhostSignIn />} />
         
          
        </Routes>
      </Wrapper>
    </div>
  );
}

export default App;
